import {UA} from '@colonist/mobile'

export class UIDeviceController {
    static _isUserOnMobileWebview: boolean | undefined = undefined
    static _isCypressTest: boolean | undefined = undefined

    static isUserOnTabletApp() {
        if(window.location.hostname.includes('discordsays')) return false
        if(this.isUserOnMobileApp() && window.location.search.includes('tablet=1')) return true

        const userAgent = navigator.userAgent
        const tabletUserAgents = [UA.IPAD_APP_USER_AGENT, UA.TABLET_APP_USER_AGENT]
        return tabletUserAgents.includes(userAgent)
    }

    static isUserOnMobileApp(): boolean {
        if(window.location.hostname.includes('discordsays')) return false

        const userAgent = navigator.userAgent
        const mobileUserAgents = [UA.IPHONE_APP_USER_AGENT, UA.IPAD_APP_USER_AGENT, UA.TABLET_APP_USER_AGENT, UA.ANDROID_APP_USER_AGENT]
        return mobileUserAgents.includes(userAgent) || window.location.pathname.includes('/mobile')
    }

    static isUserOnIOSApp(): boolean {
        if(window.location.hostname.includes('discordsays')) return false

        const userAgent = navigator.userAgent
        const iosUserAgents = [UA.IPHONE_APP_USER_AGENT, UA.IPAD_APP_USER_AGENT]
        return iosUserAgents.includes(userAgent)
    }

    /**
     * @deprecated only works in the discord mount, find a better way
     */
    static isUserOnDiscordMobile() {
        if(!window.location.hostname.includes('discordsays')) return false

        const urlParams = new URLSearchParams(new URL(window.location.href).search)
        const platform = urlParams.get('platform')
        return platform == 'mobile'
    }

    static isUserOnSafariOrIOS(): boolean {
        const userAgent = navigator.userAgent.toLowerCase()
        const isIOS = /ipad|iphone|ipod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome')
        return isIOS || isSafari
    }

    static isUserOnMobileWebview(): boolean {
        if(this._isUserOnMobileWebview != undefined) return this._isUserOnMobileWebview

        this._isUserOnMobileWebview = this.isUserOnMobileApp() || this.isUserOnTabletApp() || this.isUserOnDiscordMobile()
        return this._isUserOnMobileWebview
    }

    static isCypressTest(): boolean {
        if(this._isCypressTest != undefined) return this._isCypressTest

        this._isCypressTest = typeof (window as any).Cypress !== 'undefined'
        return this._isCypressTest
    }

    static isUserOnMobileDevice(): boolean {
        const userAgent = navigator.userAgent
        return /Android|iPhone|iPad|iPod/i.test(userAgent)
    }

    static isUserOnMobileWebBrowser(): boolean {
        if(window.location.hostname.includes('discordsays')) return false
        if(!this.isUserOnMobileDevice()) return false

        const userAgent = navigator.userAgent
        const mobileWebViewAgents = [UA.IPHONE_APP_USER_AGENT, UA.IPAD_APP_USER_AGENT, UA.TABLET_APP_USER_AGENT, UA.ANDROID_APP_USER_AGENT]
        const isNotMobileWebViewAgent = !mobileWebViewAgents.includes(userAgent)
        return isNotMobileWebViewAgent
    }
}
